const authRoutes = [
  {
    path: '',
    component: () => import('@/app/shared/layouts/full-page/FullPage.vue'),
    children: [
      // =============================================================================
      // PAGES
      // =============================================================================
      {
        path: '/auth/callback',
        name: 'authCallback',
        component: () => import('@/app/auth/views/Callback.vue'),
        meta: {
          rule: 'editor'
        }
      },
      {
        path: '/auth/login',
        name: 'authLogin',
        component: () => import('@/app/auth/views/Login.vue'),
        meta: {
          rule: 'editor'
        }
      },
      {
        path: '/auth/register',
        name: 'authRegister',
        component: () => import('@/app/auth/views/Register.vue'),
        meta: {
          rule: 'editor'
        }
      },
      {
        path: '/auth/forgot-password',
        name: 'authForgotPassword',
        component: () => import('@/app/auth/views/ForgotPassword.vue'),
        meta: {
          rule: 'editor'
        }
      },
      {
        path: '/auth/reset-password',
        name: 'authResetPassword',
        component: () => import('@/app/auth/views/ResetPassword.vue'),
        meta: {
          rule: 'editor'
        }
      },
      {
        path: '/auth/lock-screen',
        name: 'authLockScreen',
        component: () => import('@/app/auth/views/LockScreen.vue'),
        meta: {
          rule: 'editor'
        }
      },
    ]
  }
];

export default authRoutes;
